import { updateBreadcrumbTitle } from './utilities/updateBreadcrumbTitle';
import { initializeQuote } from './components/Quote/initializeQuote';
import { initializeFindStorePrompt } from './utilities/findStore';

(async ({
  productTitle,
  storeDetails,
  vehicleInformation,
  product,
  product2,
  TDSTANDARD,
  ECONOMY,
  TRAILER,
  pricing,
} = {}) => {
  const lastBreadcrumb = document.querySelector('.cmp-breadcrumbs li:nth-last-child(2) a');
  updateBreadcrumbTitle(productTitle, lastBreadcrumb);

  if (storeDetails) {
    initializeQuote(
      storeDetails,
      vehicleInformation,
      product,
      product2,
      TDSTANDARD,
      ECONOMY,
      TRAILER,
      pricing,
    );

    // if URL contains michelinClick2Buy reload to read new cookie(s)
    if (document.location.search.includes('michelinClick2Buy')) {
      setTimeout(() => {
        document.location = document.location.pathname;
      }, 150);
    }
  } else {
    initializeFindStorePrompt();
  }
})(window.drupalSettings);
